import { render, staticRenderFns } from "./input5PrevData.vue?vue&type=template&id=a718a222&scoped=true"
import script from "./input5PrevData.vue?vue&type=script&lang=js"
export * from "./input5PrevData.vue?vue&type=script&lang=js"
import style0 from "./input5PrevData.vue?vue&type=style&index=0&id=a718a222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a718a222",
  null
  
)

export default component.exports